module.exports = __webpack_public_path__ + "static/media/dropbox.b08c8faf.svg";